<template>
    <div>
        <a-popconfirm ok-text="Save"
					  cancel-text="Cancel"
                      @confirm="onSubmit"
                      @cancel="handleCancel"
        >
            <template slot="title">
                <a-card :bordered="false">
                    <a-row :gutter="[12]">
                        <a-form-model ref="editForm">
                             <a-col :span="24">
					            <a-form-model-item class="mb-10" 
                                                   label="Comment" 
                                                   :colon="false"
                                >
						            <a-textarea placeholder="Basic usage" :rows="2" v-model="comment"/>
					            </a-form-model-item>
				            </a-col>

                            <a-col :span="24" v-if="groupOptions != null">
					            <template v-for="(o, index) in groupOptions">
                                    <a-form-model-item :key="index"
                                                        :label="o.description"
                                                        :colon="false"
                                    >
                                        <template v-if="o.maxSelection > 1">
                                            <multiselect placeholder="Please pick some" 
                                                        :options="o.options" 
                                                        :multiple="true"
                                                        :max="o.maxSelection" 
                                                        :searchable="false"
                                                        :hideSelected="true"
                                                        :allowEmpty="true"
                                                        :taggable="true"
                                                        label="description"
                                                        track-by="index"
                                                        v-model="groupOptionsModels[index]"
                                                        @select="handleMultipleOptionsOnSelect"
                                                        @remove="handleMultipleOptionsOnRemove"
                                            >
                                            </multiselect>
                                        </template>

                                        <template v-else>
                                            <multiselect placeholder="Please select" 
                                                    :options="o.options" 
                                                    :searchable="false"
                                                    :allowEmpty="true"
                                                    label="description"
                                                    track-by="index"
                                                    v-model="groupOptionsModels[index]"
                                                    @select="handleSingleOptionOnSelect"
                                                    @remove="handleSingleOptionOnRemove"
                                            >
                                            </multiselect>
                                        </template>
                                    </a-form-model-item>
                                </template>
				            </a-col>
                        </a-form-model>
                    </a-row>
                </a-card>
												
			</template>
            <a-button shape="circle" icon="form" size="small" />
        </a-popconfirm>
    </div>
</template>

<script>

export default {
    props : ['groupOptionsJSON', 'rowIndex'],
    
    components : {

    },
    data () {
        return {
            groupOptions : [],
            groupOptionsModels : [],
            comment : '',
            customGroupOptions : '',
        }
    }, 
    methods : {

        onSubmit() {

            let options = [];

            for(let i = 0; i < this.groupOptionsModels.length; i++) {
                //
                //Multiple selection
                //
                if( Array.isArray(this.groupOptionsModels[i]) ) {

                    if(this.groupOptionsModels[i].length > 0) {
                        let price = 0.0;
                        //let otp = '';
                        let parentDescription = this.groupOptions[this.groupOptionsModels[i][0].parentIndex].description; 
                        //let index = 0;
                        
                        this.groupOptionsModels[i].forEach(o => {
                            //
                            //Added price
                            //
                            if(this.groupOptionsModels[o.parentIndex].priceType == 0) {
                                price += parseFloat(o.price);
                            }
                            //
                            //Max price
                            //
                            else {
                                if (parseFloat(o.price) > price) {
                                    price = parseFloat(o.price);
                                }
                            }
                            //
                            //
                            //
                            // if(this.groupOptionsModels[i].length - index > 1) {
                            //     otp = otp + o.description + ', ';
                            // }
                            // else {
                            //     otp = otp + o.description;
                            // }
                            //index++;
                        });
                        
                        let option = {
                            codeName : this.groupOptionsModels[i].codeName,
                            description : parentDescription,
                            priceType : this.groupOptions[this.groupOptionsModels[i][0].parentIndex].priceType,
                            maxSelection : this.groupOptions[this.groupOptionsModels[i][0].parentIndex].maxSelection,
                            options : [],
                            addedPrice : price,
                        };

                        this.groupOptionsModels[i].forEach(o => {
                            let subOption = {
                                description : o.description,
                                shortName : o.shortName,
                                price : o.price
                            }
                            option.options.push(subOption);
                        });

                        options.push(option);
                    }
                    
                }

                //
                //Single selection
                //
                else {
                    if(this.groupOptionsModels[i]) {
                        let option = {
                            codeName : this.groupOptionsModels[i].codeName,
                            description : this.groupOptions[this.groupOptionsModels[i].parentIndex].description,
                            priceType : this.groupOptions[this.groupOptionsModels[i].parentIndex].priceType,
                            maxSelection : this.groupOptions[this.groupOptionsModels[i].parentIndex].maxSelection,
                            addedPrice : parseFloat(this.groupOptionsModels[i].price),
                            options : []
                        };
                        let subOption = {
                            description : this.groupOptionsModels[i].description,
                            shortName : this.groupOptionsModels[i].shortName,
                            price : this.groupOptionsModels[i].price
                        }
                        option.options.push(subOption);
                        options.push(option);
                    }
                }
            }
            //reset();
            this.$emit('onSubmit', {'index': this.rowIndex, 'options' : options, 'comment': this.comment  });
        },

        handleCancel() {

        },

        handleMultipleOptionsOnSelect(value) {
            //console.log(this.groupOptionsModels);
        }, 

        handleMultipleOptionsOnRemove(value) {
            //console.log(this.groupOptionsModels);
        },

        handleSingleOptionOnSelect(value) {
            //console.log(this.groupOptionsModels);

        },

        handleSingleOptionOnRemove(value) {
            //console.log(this.groupOptionsModels);
        },

        reset() {
            this.groupOptions = [];
            this.comment = '';
            this.customGroupOptions = '';

        }
    },
    mounted () {
       
        if (this.groupOptionsJSON != null) {
            try {
                this.groupOptions = JSON.parse(this.groupOptionsJSON);
                //console.log(this.groupOptions)
                this.groupOptionsModels = new Array(this.groupOptions.length);
                this.groupOptionsModels.forEach(o => {
                    o = [];
                })
                // for (let i = 0; i < this.groupOptions.length; i++) {
                //     let groupOption = {
                //         codeName : this.groupOptions[i].codeName,
                //         description : this.groupOptions[i].description,
                //         maxSelection : this.groupOptions[i].maxSelection,
                //         priceType : this.groupOptions[i].priceType,
                //         options : []
                //     }
                //     this.groupOptionsModels[i] = groupOption;
                // }
                // console.log(this.groupOptionsModels)
                
                for(let parentIndex = 0; parentIndex < this.groupOptions.length; parentIndex++) {
                    this.groupOptions[parentIndex].options.forEach(sub => {
                        sub.parentIndex = parentIndex;
                        sub.codeName = this.groupOptions[parentIndex].codeName;
                       
                    });
                }
            }
            catch(ex) {
                console.log('Parsing exception! - ' + ex);
            }
        }

       
    }
}
</script>

<style>

</style>